import { registerWebComponents } from "./web-components/index.js";
/**
 * Web Components Registration
 * Auto-register web components on window load
 */
if(!window.webComponentsRegistered) {
    // Register web components only once
    registerWebComponents();
    window.webComponentsRegistered = true;  
}
document.addEventListener('invoke-action', (event:Event) => {
    const customEvent = event as CustomEvent;
    const detail = customEvent.detail;
    if(detail && detail.action) {
        const actionFunc = (window as any)[detail.action];
        if(typeof actionFunc === 'function') {
            actionFunc();
        } else {
            console.warn(`Action function ${detail.action} not found on window.`);
        }
    }
})